
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import { IBreadCrumb } from "winfakt-vue-components";
/*import { CashDro, ICashdroConfiguration } from "@/plugins/cashdro/cashdro";
import {Dossier} from "@/models/dossier/dossier";
import {DossierConfig} from "@/models/dossier-config";*/
import {AuthService, DossierConfigService} from "@/services";
import {MODULE} from "@/config/modules";

export default Vue.extend({
	data(){
		return {
			allow: DossierConfigService.getGeneralConfig().AutoShopSynch,
			path: [{
				to: "/settings/plugins", value: this.$ct("components.settings-plugin.plugins")
			}, {value: this.$ct("components.settings-plugin.shop")}] as IBreadCrumb[],
		};
	},
	computed: {
		hasModule():boolean{
			return AuthService.hasModule(MODULE.WEBSHOP);
		}
	},
	methods: {
		async save(){
			let conf = DossierConfigService.getGeneralConfig();
			conf.AutoShopSynch = this.allow;
			await DossierConfigService.saveGeneralConfig(conf);
			this.$wf.notify(this.$ct("saved"), "success", 3000, "check");
		}
	},
	components: {
		AppMobileFullScreenContainer
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin"
	},
});
